import { createEnvGetter } from './createEnvGetter';
export const getBaseUrl = createEnvGetter('FW_BASE_URL');
export const getBaseApiUrl = createEnvGetter('FW_BASE_API_URL');
export const getHasuraApiUrl = createEnvGetter('FW_HASURA_API_URL');
export const getRenderingApiUrl = createEnvGetter('FW_RENDERING_API_URL');
export const getHeroUrl = createEnvGetter('FW_HERO_URL');
export const getShopRendererApiUrl = createEnvGetter('FW_SHOP_RENDERER_API_URL');
export const getAuthUrl = createEnvGetter('FW_AUTH_URL');
export const getChatbotUrl = createEnvGetter('FW_CHATBOT_URL');
export const getUpscalerUrl = createEnvGetter('FW_UPSCALER_URL');
export const getCurrentEnvironment = createEnvGetter('FW_ENV', { suffixAble: false });
export const getSentryDsn = createEnvGetter('FW_SENTRY_DSN');
export const getCommitHash = createEnvGetter('FW_COMMIT_HASH');
export const getMyShopUrl = createEnvGetter('FW_MY_SHOP_URL');
export const getRegisterUrl = createEnvGetter('FW_REGISTER_URL');
export const getProductCatalogUrl = createEnvGetter('FW_PRODUCT_CATALOG_URL');
